import { getRoutes } from '@change-corgi/config/routes';
import type { Routes } from '@change-corgi/config/routes';

import { useLocale } from 'src/app/shared/hooks/l10n';

export function useRoutes(): Routes {
	const locale = useLocale();
	return getRoutes(locale) || getRoutes('en-US');
}
